import { type ClassValue, clsx } from "clsx"
import { parse, format, isValid, parseISO } from 'date-fns';

import { twMerge } from "tailwind-merge"


export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const parseDate = (date: string | Date) => {
  const parsedDate = typeof date === "string" ? parseISO(date) : date;
  return isValid(parsedDate) ? parsedDate : new Date();
};
